import React from 'react';
import List from './List';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { Add } from './Add';

const routesFactory = (path: string) => ({
  list: `${path}/`,
  add: `${path}/add`,
});

export default function Discovery() {
  const { path } = useRouteMatch();
  const routes = routesFactory(path);
  return (
    <>
      <Switch>
        <Route path={routes.list} exact component={List} />
        <Route path={routes.add} component={Add} />
      </Switch>
    </>
  );
}
